import React from 'react'
import renderHtml from 'react-render-html'
import { CCol, CCard, CCardHeader, CCardBody } from '@coreui/react'

export default function BookmarkCard(props) {
  const colors = ['primary', 'secondary', 'dark', 'success', 'danger', 'warning', 'info']
  const color = colors[Math.floor(Math.random() * colors.length)];
  return (
    <CCol xs="12" sm="6" md="3">
      <CCard color={`${color}`} className="text-white bookmark-card">
        <CCardHeader>{renderHtml(props.title)}</CCardHeader>
        <CCardBody>
          {props.content && renderHtml(props.content)}
        </CCardBody>
      </CCard>
    </CCol>
  )
}
